module.exports = __webpack_public_path__ + "static/media/attack-3.c173e38a.png";